import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeDateFormattedSelector } from "~/store/selectors/selector.dateTime.jsx";

const FormatDate = ({ value, long }) => {
  const getDateFormatted = useMemo(makeDateFormattedSelector, []);
  const children = useSelector((state) => getDateFormatted(state, value, long));
  return children;
};

FormatDate.propTypes = {
  value: PropTypes.number,
  long: PropTypes.bool,
};

FormatDate.defaultProps = {
  long: false,
};

FormatDate.displayName = "FormatDate";

export default FormatDate;
